var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3907_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#3DCBB1",
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.344828 20C0.344828 9.14475 9.14475 0.344828 20 0.344828C30.8553 0.344828 39.6552 9.14475 39.6552 20C39.6552 30.8553 30.8553 39.6552 20 39.6552C9.14475 39.6552 0.344828 30.8553 0.344828 20Z",
    stroke: "white",
    strokeOpacity: 0.23,
    strokeWidth: 0.689655
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3907_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 18.5446L23.756 13.4665C23.5237 13.2341 23.1465 13.2308 22.9142 13.4631C22.6818 13.6955 22.6785 14.0726 22.9108 14.305L26.9417 18.3695H12.3202C11.9902 18.3695 11.7241 18.6355 11.7241 18.9655C11.7241 19.2956 11.9902 19.5616 12.3202 19.5616H26.9417L22.9108 23.6261C22.6785 23.8585 22.6818 24.2356 22.9142 24.468C23.1465 24.7003 23.5237 24.697 23.756 24.4646L28.7938 19.3865C29.0227 19.1541 29.0227 18.777 28.7938 18.5446Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3907_544",
    x: -13.7931,
    y: -13.7931,
    width: 67.5862,
    height: 67.5862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.89655
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3907_544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3907_544",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3907_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2414,
    height: 17.2414,
    fill: "white",
    transform: "translate(11.7241 10.3448)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendIcon);
export default __webpack_public_path__ + "static/media/chat-send-icon.d95800da96bbcb75d5bf44d4cdb61e7b.svg";
export { ForwardRef as ReactComponent };